import { render, staticRenderFns } from "./terms_table.vue?vue&type=template&id=ec182b06"
import script from "./terms_table.vue?vue&type=script&lang=js"
export * from "./terms_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports